// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    Apply: 'Anwenden',
    Approver_Approved: 'hat bestätigt',
    Approver_HasNotSeen: 'ungelesen',
    Approver_NoAction: 'keine Aktion',
    Approver_NotApproved: 'Angesehen, Bestätigung ausstehend',
    Approver_Rejected: 'hat abgelehnt',
    ApproversGroupTitle: 'Bestätigende Personen',
    Attachment_Delete: 'Datei \'{0}\' wurde entfernt.',
    BaseNotificationRule: 'Basierend auf Benachrichtigungsregel',
    BeforePageUnloadMessage: 'Ihre Änderungen sind nicht gespeichert. Wollen Sie die Seite ohne Speicherung der Änderungen verlassen?',
    Cancel: 'Abbrechen',
    Close: 'Schließen',
    ContactAdministrator: 'Bitte Administrator kontaktieren',
    Delete: 'Löschen',
    DeleteAttachmentContentTemplate: 'Wollen Sie wirklich den Anhang \'{0}\' löschen?',
    DeleteAttachmentTitle: 'Anhang löschen',
    Download: 'Herunterladen',
    DropHere: 'Dateien hier ablegen',
    Edit: 'Bearbeiten',
    edit_actions: 'Drücken Sie Strg+Eingabe zum <a apply>Anwenden</a> oder Esc zum <a>Abbrechen</a>',
    Error: 'Fehler',
    FilePlural: '1#{0} Datei#{0} Dateien',
    FileUploadError: 'Fehler',
    FileVersion: 'Version ',
    FileVersionShort: 'ver ',
    FreeSpaceTemplate: 'Sie haben {0} MB von {1} MB genutzt.',
    HideFiles: 'Dateien ausblenden',
    Message_Delete: 'Nachricht wurde gelöscht.',
    MessageDeleteConfirmation: 'Diesen Eintrag löschen?',
    MessageEditedBy: 'Bearbeitet von ',
    MultipleApproversTemplate: '{0} von {1} {2}',
    NewMessageWatermark: 'Nachrichten eingeben oder Dateien ablegen …',
    NewPost: '1#{0} neuer Eintrag #{0} neue Einträge',
    No: 'Nein',
    NoMatchRecipients: 'Mitglied nicht gefunden',
    NoPermissionToEditMessage: 'Sie haben leider keine Befugnisse, diese Nachricht zu bearbeiten',
    Notification: 'Benachrichtigung',
    Notify: 'Benachrichtigen',
    NotifyLabel: 'Benachrichtigen …',
    NotProjectMembers: 'Keine Projektmitglieder',
    Or: 'oder',
    PluralApproved: '1#bestätigt#bestätigt',
    PluralRejected: '1#{0} abgelehnt#{0} abgelehnt',
    Post: 'Beitrag',
    PostWatingForApproval: 'Beitrag wartet auf Bestätigung',
    PreviewImages: 'Bildvorschau',
    ProjectMembers: 'Projektmitglieder',
    RequestApprovalLabel: 'Bestätigung anfordern',
    ShowFiles: 'Dateien anzeigen',
    ShowNext: 'Vorherige anzeigen',
    SingleApprovedTemplate: 'Bestätigt von {0}',
    SingleApprovedTemplate_You: 'Bestätigt von Ihnen.',
    SingleApproverTemplate: 'Wartet auf Bestätigung von {0}',
    SingleRejectedTemplate: 'Abgelehnt von {0}',
    SingleRejectedTemplate_You: 'Abgelehnt von Ihnen.',
    TabFiles: 'Dateien',
    TabMessages: 'Nachrichten',
    Teams: 'Teams',
    UploadedBy: ' von ',
    Yes: 'Ja',
    You: 'Sie',
};
